import { debounce } from "throttle-debounce-ts";

const search = {
	init: (): void => {
		const headerSearchForm = <HTMLInputElement>(
			document.querySelector("#search")
		);
		const headerSearchResults = <HTMLHtmlElement>(
			document.querySelector(".search-overlay")
		);
		const headerSearchItems = <HTMLHtmlElement>(
			document.querySelector(".search-overlay__searchItems")
		);
		search.headerSearch(
			headerSearchForm,
			headerSearchResults,
			headerSearchItems,
		);
		search.input(headerSearchForm, headerSearchResults);

		document.addEventListener("click", (e) => {
			const isClickInsideHeaderSearchResults = headerSearchResults?.contains(
				e.target as Node,
			);
			const isButtonClickedHeaderSearchResults = headerSearchForm?.contains(
				e.target as Node,
			);
			// rome-ignore lint/complexity/useSimplifiedLogicExpression: <explanation>
			if (
				!isClickInsideHeaderSearchResults &&
				!isButtonClickedHeaderSearchResults
			) {
				headerSearchResults?.classList.remove("open");
			}
		});
	},

	input: (searchForm, searchResults): void => {
		searchForm?.addEventListener("focus", () => {
			searchResults?.classList.add("open");
		});

		//searchForm?.addEventListener('blur', (e) => {
		//  searchResults?.classList.remove('open');
		//});
	},

	headerSearch: (searchForm, searchResults, searchItems): void => {
		const debouncedSearch = debounce(500, handleSearch); // Set your desired debounce delay here (in milliseconds)

		searchForm?.addEventListener("input", (e) => debouncedSearch(e));
		function handleSearch(e) {
			const target = e.target as HTMLInputElement;
			const value = target?.value;
			const culture =
				document.querySelector<HTMLInputElement>("#culture")?.value;
			if (value.length > 2) {
				const allResults = document.querySelectorAll(".search__allResults");
				if (allResults != null) {
					for (let i = 0; i < allResults.length; i++) {
						const allResult = <HTMLAnchorElement>allResults[i];
						allResult.href = `${allResult.href.split("=")[0]}=${value}`;
					}
				}

				const xhr = new XMLHttpRequest();

				xhr.open(
					"GET",
					`/Umbraco/Surface/Search/Search?query=${value}&limit=0&culture=${culture}`,
				);
				xhr.setRequestHeader(
					"Content-Type",
					"application/x-www-form-urlencoded",
				);
				xhr.responseType = "json";

				xhr.onload = () => {
					let resp = xhr.response;

					if (typeof resp === "string") {
						resp = JSON.parse(resp);
					}

					if (xhr.status === 200 && resp.success) {
						let dataLength = resp.data.length;

						if (dataLength > 4) {
							dataLength = 4;
						}

						let html = `<div class="search__total body2 ${
							resp.data.length > 0 ? " has-data" : ""
						}">Það fundust ${
							resp.data.length
						} leitarniðurstöður fyrir <span class="search__value">"${value}"</span></div>`;

						for (let i = 0; i < dataLength; i++) {
							const data = resp.data[i];

							html += `
                <a href="${data.url}" class="search__item">
                  <div class="search__header headline3">${data.name}</div>
                  <div class="search__breadcrumbs body2">${data.breadcrumbs}</div>
                </div>`;
						}

						searchResults?.classList.add("open", "showDialog");

						if (searchItems != null) {
							searchItems.innerHTML = html;
						}
					} else {
					}
				};

				xhr.send();
			} else {
				searchResults?.classList.remove("showDialog");
			}
		}
	},

	quickSearch: (): void => {},
};

export default search;
